module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-86.5502651.woff2";